<template>
  <div class="page-content">
    <div class="headings">
      <h2 class="title title-primary">{{ location }}</h2>
      <span>|</span>
      <h2 class="title title-primary">
        {{ $t("lang.inventory.dashboard.page_title_line_1") }}
      </h2>
      <span>|</span>
      <h3 class="title title-primary">
        {{ $t("lang.inventory.dashboard.page_title_line_2") }}
      </h3>
    </div>
    <div class="page-header">
      <div class="boxes" v-if="!shouldLoading">
        <bx-box dark color="outline" class="col-6 col-md-auto p-1">
          <bx-value
            :label="$t('lang.inventory.dashboard.box_label_1')"
            :value="stats.pending_inventories"
            font-size="xs"
          />
        </bx-box>

        <bx-box dark color="outline" class="col-6 col-md-auto p-1">
          <bx-value
            :label="$t('lang.inventory.dashboard.box_label_2')"
            :value="stats.validated_inventories"
            font-size="xs"
          />
        </bx-box>

        <bx-box dark color="outline" class="col-12 col-md-auto p-1">
          <bx-value
            :label="$t('lang.inventory.dashboard.box_label_3')"
            :value="stats.total_inventory_count"
            font-size="xs"
            :icon="require('@/assets/i/boxWhiteBig.png')"
          />
        </bx-box>
      </div>
      <skeleton-boxes :boxes="5" v-else />
    </div>

    <div class="page-main-content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <bx-box
              :title="
                ordersCount + ' ' + $t('lang.inventory.dashboard.box_label_1')
              "
              no-padding
              :loading="shouldLoading"
            >
              <bx-table
                :data="data"
                :columns="columns"
                paginated
                v-if="!shouldLoading"
                backendPagination
                :currentPage="page"
                :perPage="itemsPerPage"
                :total="ordersCount"
                @search="onSearch"
                @update:currentPage="updatePage"
              >
                <template slot-scope="props">
                  <bx-table-column field="status" centered>
                    <bx-tag v-if="props.row.canceled" color="yellow">{{
                      $t("lang.inventory.box_status.label_canceled")
                    }}</bx-tag>
                    <bx-tag v-else-if="props.row.valid" color="green">{{
                      $t("lang.inventory.box_status.label_validated")
                    }}</bx-tag>
                    <bx-tag v-else color="red">{{
                      $t("lang.inventory.box_status.label_pending")
                    }}</bx-tag>
                  </bx-table-column>
                  <bx-table-column centered>
                    <router-link
                      :to="`/inventory/${props.row.id}/detail`"
                      class="bx-link bx-link-bold"
                      >{{ props.row.id }}</router-link
                    >
                  </bx-table-column>
                   <bx-table-column centered>
                    <router-link :to="`/inventory/${props.row.id}/detail-items`" class="bx-link bx-link-bold"
                      >VER DETALLE
                    </router-link>
                  </bx-table-column>
                  <bx-table-column field="date">{{
                    formatDate(props.row.date)
                  }}</bx-table-column>
                  <bx-table-column centered>
                    <bx-complementary-mini
                      :percent="props.row.stockRatingPercent"
                    ></bx-complementary-mini>
                  </bx-table-column>
                  <bx-table-column centered>{{
                    props.row.theorical
                  }}</bx-table-column>
                  <bx-table-column centered>{{
                    props.row.real
                  }}</bx-table-column>
                  <bx-table-column>
                    <img
                      @click="downloadFile(props.row.id)"
                      style="cursor: pointer"
                      src="@/assets/i/Icon-download.svg"
                    />
                  </bx-table-column>
                </template>
              </bx-table>
            </bx-box>
          </div>
        </div>
        <v-row class="d-flex d-sm-none">
          <div
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="busy"
            infinite-scroll-distance="20"
            style="width: 100%"
          >
            <v-list width="100%">
              <v-list-item
                two-line
                v-for="(item, index) in dataList"
                :key="index"
                class="green lighten-5 ma-2 rounded-lg"
                ripple
                :to="`/inventory/${item.id}/detail`"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    <div>
                      {{ item.id }}
                    </div>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-subtitle class="text-caption">
                    {{ item.real + "/" + item.theorical }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-caption">
                    {{ formatDate(item.date) }}
                  </v-list-item-subtitle>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
        </v-row>
        <skeleton-table :columns="6" v-if="shouldLoading" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import BxComplementaryMini from "../../bx-components/BxComplementaryMini";
import common from "@/utils/common";

export default {
  name: "inbound-dashboard",
  components: { BxComplementaryMini },
  mixins: [common],
  data() {
    return {
      shouldLoading: true,
      reloadInterval: null,
      ordersCount: 1,
      columns: [],
      data: [],
      dataList: [],
      pending: 12,
      completed: 34,
      total: 46,
      stats: {},
      page: 1,
      itemsPerPage: process.env.VUE_APP_ITEMS_PER_PAGE,
    };
  },
  computed: {
    location() {
      return localStorage.getItem("location");
    },
  },
  methods: {
    loadMore() {
      if (
        !this.shouldLoading &&
        this.dataList.length &&
        this.dataList.length < this.ordersCount &&
        this.isMobile
      ) {
        this.page++;
        this.getData(this.locationId);
      }
    },
    formatDate(date) {
      return date
        ? moment(date).format("DD/ MM/ YYYY, h:mm a")
        : this.$t("lang.messages.no_date_available");
    },
    onSearch(field, value) {
      this.filters[field] = value;
      this.getData();
    },
    updatePage(p) {
      this.page = p;
      this.getData(this.locationId);
    },
    async downloadFile(id) {
      try {
        await this.$api.inventories.download(id);
      } catch (error) {
        console.log(error);
      }
    },
    async getData() {
      try {
        if (this.isMobile) {
          this.shouldLoading = true;
        }
        // Load stats
        let location = localStorage.getItem("location");
        let locationId = localStorage.getItem("location_id");
        if (!location || !locationId) {
          try {
            let firstLocation = await this.$api.location.search("", {
              limit: 1,
              offset: 0,
              orderBy: "id",
            });
            location = firstLocation.results[0].description;
            locationId = firstLocation.results[0].id;
          } catch (error) {
            console.log(error);
          }
        }

        this.stats = await this.$api.location.inventoryStats(locationId);

        // Load inventories
        const inventories = await this.$api.inventories.list(locationId, {
          offset: (this.page - 1) * this.itemsPerPage,
          limit: this.itemsPerPage,
        });
        this.ordersCount = inventories.count;
        this.data = inventories.results.map((item) => {
          return {
            id: item.id,
            valid: item.valid,
            date: item.start_time,
            stockRatingPercent:
              item.theorical_stock < item.matched_items
                ? (item.theorical_stock / item.matched_items) * 100
                : (item.matched_items / item.theorical_stock) * 100,
            ismore: item.theorical_stock < item.matched_items,
            real: item.items,
            theorical: item.theorical_stock,
            canceled: item.canceled,
          };
        });

        if (this.isMobile) {
          this.dataList = this.dataList.concat(this.data);
        }

        this.columns = [
          {
            field: "status",
            label: this.$t("lang.inventory.dashboard.table_field_1"),
            width: "120",
            centered: true,
          },
          {
            field: "id",
            label: this.$t("lang.inventory.dashboard.table_field_2"),
            width: "120",
            centered: true,
          },
          {
            field: "items",
            label: "ITEMS",
            centered: true
          },
          {
            field: "date",
            label: this.$t("lang.inventory.dashboard.table_field_3"),
          },
          {
            field: "stockRating",
            label: this.$t("lang.inventory.dashboard.table_field_4"),
            centered: true,
          },
          {
            field: "theorical",
            label: this.$t("lang.inventory.dashboard.table_field_5"),
            centered: true,
          },
          {
            field: "real",
            label: this.$t("lang.inventory.dashboard.table_field_6"),
            centered: true,
          },
          {
            field: "report",
            label: this.$t("lang.inventory.dashboard.report"),
            centered: true,
          },
        ];
      } catch (error) {
        // console.log(error)
      } finally {
        this.shouldLoading = false;
      }
    },
  },
  mounted() {
    if (!this.isMobile) {
      this.reloadInterval = setInterval(
        this.getData,
        process.env.VUE_APP_RELOAD_TIME
      );
    }

    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.reloadInterval);
  },
};
</script>
